
// 公共CDN资源地址
export const remoteCdn = 'https://stc.yxt.com/ufd/55a3e0/ote';
// 老的mediasvg迁移后的地址
export const SvgMediaUrl = remoteCdn + '/pc/other/ote/svg';

// 试题题型 0-单选题 1-多选题 2-判断题 3-填空题 4-问答题 5-组合题
export const QUES_TYPE_NAMES = ['pc_ote_lbl_singlechoice', 'pc_ote_lbl_multiplechoice', 'pc_ote_lbl_judgment', 'pc_ote_lbl_fillin', 'pc_ote_lbl_question', 'pc_ote_lbl_combinatorialquestions'];

// 试题难度 0-易 1-中 2-难
// 试题难度全量 0-易 3-较易 1-中 4-较难 2-难
export const QUES_LEVEL_NAMES = {
  0: 'pc_ote_lbl_easy',
  1: 'pc_ote_lbl_medium',
  2: 'pc_ote_lbl_difficult',
  3: 'pc_ote_lbl_littleeasy',
  4: 'pc_ote_lbl_littledifficult',

  // 实际开启的难易度及其顺序，通常用于筛选等菜单。 全量开启时： 0-易 3-较易 1-中 4-较难 2-难  默认： 0-易 1-中 2-难
  // values: [0, 3, 1, 4, 2],
  values: [0, 1, 2],

  // 全量的难易度，用于展示现有数据的难易度。
  fullValues: [0, 3, 1, 4, 2],
  // 减量的难易度
  simpleValues: [0, 1, 2]
};
QUES_LEVEL_NAMES.values = QUES_LEVEL_NAMES.simpleValues;
export const changeLevelType = (all, cb) => {
  const newValues = all ? QUES_LEVEL_NAMES.fullValues : QUES_LEVEL_NAMES.simpleValues;
  if (newValues !== QUES_LEVEL_NAMES.values) {
    QUES_LEVEL_NAMES.values = newValues;
    cb && typeof (cb) === 'function' && cb();
  }
};
